
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tournaments",
      function () {
        return require("private-next-pages/tournaments/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tournaments"])
      });
    }
  